import Carriers from "../../views/carriers/Index.vue";

const CarriersRoute = [
  {
    path: "/carriers",
    name: "Carriers",
    component: Carriers,
  },
];

export default CarriersRoute;
